var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"btn",class:_vm.buttonStyle,attrs:{"block":_vm.isBlock,"href":_vm.href,"loading":_vm.loading,"width":_vm.width,"height":_vm.height,"outlined":_vm.outlined,"disabled":_vm.disabled,"to":_vm.to},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }